import { CheckIcon } from "@heroicons/react/24/outline";
import Button from "../components/button/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { FormEvent } from "react";
import authApi from "../api/Auth.api";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../features/alert.slice";

export const RegisterSend = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const state = location.state ;

  const dispatch = useDispatch();

  const mainMessage = '確認用メールを送信しました';
  const subMessage = 'メールの内容を確認して、登録を完了してください。';

  //メール再送信
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const result = await authApi.registerPageRequestSendEmail(state);
    if(result.success) {
      dispatch(alertOpen(AlertValue(mainMessage, "success", subMessage)));
    } else {
      dispatch(alertOpen(AlertValue('メール送信に失敗しました。', "danger", '管理者へお問い合わせください。')));
    }
  };

  return (
    <div className="p-4 space-y-4">
      <div className="flex sm:w-full sm:max-w-md space-x-2">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
        </div>
        <h2 className="text-center pt-1 text-3xl font-bold tracking-tight text-gray-900">
          {mainMessage}
        </h2>
      </div>
      <form
        className="sm:w-full sm:max-w-lg space-y-4 px-4"
        onSubmit={(e) => handleSubmit(e)}
        method="POST"
      >
        <div>
            メールアドレス
          <div className="mt-1">
              {state}
          </div>
        </div>
        <div>
          {mainMessage}
          <div className="mt-1">
            {subMessage}
          </div>
        </div>
        <div>
          確認メールは「no-reply@admin.event-support.site」から送信されます。
        </div>
        <Button
          submit
          color={"yellow"}
          outline
          block
          children={"メールの再送"}
          className="max-w-md"
        />
        <Button
          onClick={() => navigation("/register")}
          outline
          block
          children={"別のアドレスで登録する"}
          className="max-w-md"
        />
      </form>
    </div>
  );
};
